import { useParams } from 'react-router-dom';
import { municipalityApiKeyStore } from '../../../../api/masters/municipality-api-key-store';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { SiTrackPage } from '../../../../components/si-track-page';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Municipality } from '../../../../models/masters/municipality';

import SaveMunicipality from './save_municipality';

export const EditMunicipalityPage = () => {
  const { municipalityID } = useParams();
  const { isLoading, data } = useLoadData<ApiResponse<Municipality>>(
    municipalityApiKeyStore.getMunicipality(Number(municipalityID))
  );

  return (
    <SiTrackPage title="Edit Municipality">
      <LoadingIndicator isLoading={isLoading} />
      {data?.data && <SaveMunicipality municipality={data?.data} />}
    </SiTrackPage>
  );
};
